import React, { useEffect } from 'react'
import styled from 'styled-components'
import Lottie from 'lottie-react'
import ArrowLottie from 'src/assets/images/rop03/arrow.json'
import { useModal } from 'src/components/Modal/provider'
import { getTermsModalCopy } from 'src/constants/terms/messages'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { Button } from 'src/pages/Rop03JoinFormPage/components/Button'

export interface RopTermsModalChildrenProps {
  otpCertRequest: () => void
  allTermsAgreeHandler: (tf?: boolean) => void
  isLoading: boolean
}

const RopTermsModalChildren = ({
  otpCertRequest,
  allTermsAgreeHandler,
  isLoading,
}: RopTermsModalChildrenProps) => {
  const { closeModal } = useModal()
  const { telecom, fixedTelecom } = useParamsList()
  const { title, desc } = getTermsModalCopy(fixedTelecom || telecom)

  let isReady = false
  const timer = setTimeout(() => {
    isReady = true
  }, 100)

  const handleSubmit = () => {
    allTermsAgreeHandler()
    otpCertRequest()
    closeModal()
  }

  const handleCancel = () => {
    closeModal()
  }

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && isReady && !isLoading) {
        handleSubmit()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('keydown', handleKeyDown)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <TermsModalContainer data-lenis-prevent-wheel data-lenis-prevent-touch>
      <ModalTitle>{title}</ModalTitle>
      <ModalDesc>{desc}</ModalDesc>
      <ButtonWrap>
        <Button.Default onClick={handleCancel}>닫기</Button.Default>
        <Button.JoinSubmit
          type="button"
          name="확인"
          onClick={handleSubmit}
          icon={<Lottie animationData={ArrowLottie} loop autoplay />}
          iconAlt=""
          iconSize={26}
          isLoading={isLoading}
        />
      </ButtonWrap>
    </TermsModalContainer>
  )
}

export default RopTermsModalChildren

const TermsModalContainer = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
`
const ModalTitle = styled.strong`
  color: #25282e;
  text-align: center;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
`

const ModalDesc = styled.p`
  margin-top: 12px;
  color: #313338;
  text-align: center;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: pre-line;
`
const ButtonWrap = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 20px;

  & button {
    height: 48px !important;
  }

  & button:nth-child(1) {
    padding: 0 18px;
    width: fit-content;
    word-break: keep-all;
  }

  & button:nth-child(2) {
    font-weight: 700;
    letter-spacing: normal;
  }
`
